/* eslint-disable */
(function podcasttranscript($, Drupal) {
  Drupal.behaviors.podcasttranscript = {
    attach(context) {

      once('podcasttranscript', 'html').forEach(function (element) {

        $('#podcast-teaser__transcript-close').on('click', (e) => {
          $('#podcast-teaser__transcript').slideToggle();
          $('#podcast-teaser__transcript-toggle').text('View Transcript');
        });
  
        $('#podcast-teaser__transcript-toggle').on('click', (e) => {
          $('#podcast-teaser__transcript').slideToggle();
          $('#podcast-teaser__transcript-toggle').text(function(i, text){
            return text === "View Transcript" ? "Close Transcript" : "View Transcript";
          })
        });

      })
     
    },
  };
}(jQuery, Drupal));
/* eslint-enable */
